export class NnDateTime {
    constructor(public date: Date) { }

    static fromISOString(dateString: string): NnDateTime {
        return new NnDateTime(new Date(dateString))
    }

    toISOString(): string {
        return this.date.toISOString()
    }

    difference(other: Date): { days: number, hours: number, minutes: number, seconds: number } {
        const difference = other.getTime() - this.date.getTime()
        const days = Math.floor(difference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((difference % (1000 * 60)) / 1000)
        return { days, hours, minutes, seconds }
    }

    humanReadableDifference(other: Date): { years: number, months: number, days: number, hours: number, minutes: number, seconds: number } {
        const { days, hours, minutes, seconds } = this.difference(other)
        const years = Math.floor(days / 365)
        const months = Math.floor((days % 365) / 30)
        const remainingDays = days % 30
        return { years, months, days: remainingDays, hours, minutes, seconds }
    }
}
